import useSignOut from "react-auth-kit/hooks/useSignOut";
import { useNavigate } from "react-router-dom";
import { MdEmail, MdPhone } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { MdAlternateEmail } from "react-icons/md";
import { MdLogout } from "react-icons/md";
import { themeColours } from "../../resources";
import "./Profile.css";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { FaCalendarAlt } from "react-icons/fa";
import { UserInfo } from "../../types";
import { EditUserOverlay } from "./EditUserOverlay";
import { useEffect, useState } from "react";
import { registerPushSubscription, unsubscribePushSubscription } from "../../hooks/usePushSubscription";
const logo = require("../../assets/logoNoBack.png");

export function Profile() {
  const signOut = useSignOut();
  const navigate = useNavigate();
  const user = useAuthUser() as UserInfo & { phone?: string | null };
  const { firstName, lastName, username, email, createdAt, phone } = user;
  const [notificationsEnabled, setNotificationsEnabled] = useState<boolean>(
    localStorage.getItem("notificationsEnabled") === "true"
  );
  useEffect(() => {
    // If permission was revoked at browser level, reflect that in UI
    if (Notification.permission === "denied") {
      setNotificationsEnabled(false);
      localStorage.setItem("notificationsEnabled", "false");
    }
  }, []);

  function handleSignOut() {
    localStorage.clear()
    signOut();
    return navigate("/login");
  }
  return (
    <div className="pageContainer">
      <div className="profilePage">
        <div className="userContainer">
          <span className="userEditIcon">
            <EditUserOverlay userInfo={user} />
          </span>
          <img src={logo} width={100} alt="logo"/>
        </div>
        <div className="userInfoContainer">
          <div className="userInfoRow">
            <span className="userInfoIcon">
              <FaUser size={30} color={themeColours.primary} />
            </span>
            <h3>{`${firstName} ${lastName}`}</h3>
          </div>
          <div className="userInfoRow">
            <span className="userInfoIcon">
              <MdAlternateEmail size={30} color={themeColours.primary} />
            </span>
            <h3>{username}</h3>
          </div>
          <div className="userInfoRow">
            <span className="userInfoIcon">
              <MdEmail size={30} color={themeColours.primary} />
            </span>
            <h3>{email ?? "No email set"}</h3>
          </div>
          <div className="userInfoRow">
            <span className="userInfoIcon">
              <MdPhone size={30} color={themeColours.primary} />
            </span>
            <h3>{phone ?? "No phone number set"}</h3>
          </div>
          <div className="userInfoRow">
            <span className="userInfoIcon">
              <FaCalendarAlt size={30} color={themeColours.primary} />
            </span>
            <h3>
              {new Date(createdAt).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </h3>
          </div>
          <div className="userInfoRow">
            <span className="userInfoIcon">
              {/* Reuse existing icon colour to keep style consistent */}
              <FaCalendarAlt size={30} color={themeColours.primary} />
            </span>
            <h3>
              Weekly notifications
            </h3>
            <input
              type="checkbox"
              checked={notificationsEnabled}
              onChange={async (e) => {
                const enabled = e.target.checked;
                if (enabled) {
                  await registerPushSubscription();
                } else {
                  await unsubscribePushSubscription();
                }
                setNotificationsEnabled(enabled);
                localStorage.setItem("notificationsEnabled", enabled ? "true" : "false");
              }}
            />
          </div>
          <div className="userInfoRow" onClick={handleSignOut}>
            <span className="userInfoIcon">
              <MdLogout size={30} color={themeColours.red} />
            </span>
            <h3 style={{ color: themeColours.red }}>Logout</h3>
          </div>
        </div>
      </div>
    </div>
  );
}
